<template>

    <div v-if="value">
        <section v-if="showOnly === false">
            <select class="form-control" v-model="defaultSelectedAddress"  >
                <option v-for="item in value.address" :value="item" :key="item.id">
                    {{ item.zipCode }} {{ item.company_name }} {{ formatStreetFormated(item.street) }} #{{ item.number }} ({{item.address_type }})
                </option>
            </select>

            <NewCustomerAddress v-model="value" v-on:new_address="newAddressAdded"
                                v-if="showCustomerAddressModal" v-on:showCustomerAddressModal="toggleModal">
            </NewCustomerAddress>

            <button class="btn btn-primary" @click="toggleModal" v-if="!showCustomerAddressModal">
                {{ 'Add Billing Address'|trans }}
            </button>
        </section>


        <div v-if="defaultSelectedAddress !== null" class="content-detail">
            <strong v-if="defaultSelectedAddress.address_type === 'intervention'">
                {{'Intervention Address'|trans}}
            </strong>
            <strong v-if="defaultSelectedAddress.address_type === 'billing'">
                {{'Billing Address'|trans}}
            </strong>
            <br>
            <span v-show="defaultSelectedAddress.company_name !== null ">
                <strong>{{'Company Name'|trans}} :</strong> {{ defaultSelectedAddress.company_name }}<br>
            </span>
            <!--<span v-show="defaultSelectedAddress.customerName !== null ">-->
                <!--<strong>{{'Name'|trans }} : </strong> {{ defaultSelectedAddress.customerName }}<br>-->
            <!--</span>-->
            <strong>{{'Street'|trans}} : </strong> {{ formatStreetFormated(defaultSelectedAddress.street) }}<br>

            <strong>{{'PostCode'|trans}} :</strong> <span v-if="defaultSelectedAddress.zone">{{ defaultSelectedAddress.zone.zip }}</span><br>

            <span v-show="defaultSelectedAddress.vat !== null ">
                <strong>{{'VAT'|trans}} : </strong> {{ defaultSelectedAddress.vat }}<br>
            </span>
        </div>

    </div>


</template>

<script>
    import NewCustomerAddress from './NewCustomerAddress';
    import Modal from '../Modal';
    export default {
        props: {
            value: null,
            showOnly: Boolean
        },
        data: function () {
            return {
                showCustomerAddressModal: false,
                defaultSelectedAddress : null
            }
        },
        created(){
            if(this.value.addressSelected!==false){
                this.defaultSelectedAddress = this.value.addressSelected;
            }else{
                this.defaultSelectedAddress = this.value.customerAddressIntervention;
            }
        },
        methods:{
            setDefaultAddressSelected(){
                this.value.address_current = this.defaultSelectedAddress;
                this.value.addressSelected = this.defaultSelectedAddress;
            },
            newAddressAdded($newAddress){
                this.$emit('new_address', $newAddress);
                this.defaultSelectedAddress = $newAddress;
            },
            toggleModal(){
                this.showCustomerAddressModal = !this.showCustomerAddressModal;
                return this.showCustomerAddressModal;
            },
            formatStreetFormated(street){
                if(street.value !== undefined){
                    return street.value;
                }
                return street;
            }
        },
        watch: {
            'defaultSelectedAddress'() {
               this.setDefaultAddressSelected()
            },
        },
        components: {
            NewCustomerAddress,
            Modal
        }
    }
</script>

<style scoped>
    .content-detail{
        padding: 10px;
        border: 1px solid #bbbbbb;
        background: #4890db;
        color: white;
    }
</style>

<style>
    .no-scroll{
        position:fixed;
    }
</style>